import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { BREAKPOINT_MEDIUM_PX } from '@/settings';
import { baseStyles } from '@/styles';

import '../messages/fg-message';

@customElement('fg-configurator-step')
export class FgConfiguratorStep extends LitElement {
  @property({ type: String })
  stepTitle: string | null = '';

  @property({ type: String })
  validationMessage?: string | null = null;

  @property({ type: Boolean })
  showValidationMessage = false;

  render() {
    return html`
      <section>
        <header>
          <h2>${this.stepTitle}</h2>
          <slot name="step-header"></slot>
        </header>
        ${this.validationMessage && this.showValidationMessage
          ? html`
              <fg-message .message=${this.validationMessage}></fg-message>
            `
          : nothing}
        <slot></slot>
      </section>
    `;
  }

  static styles = [
    baseStyles,
    css`
      header {
        display: flex;
        align-items: start;
        justify-content: space-between;
        flex-direction: column;
        gap: 10px;
          
        @media screen and (min-width: ${BREAKPOINT_MEDIUM_PX}px) {
          && {
            align-items: center;
            flex-direction: row;
            gap: 0px;     
          }
        }

      fg-message {
        display: block;
        margin-bottom: 20px;
      }

      h2 {
        font-size: 1.313rem;
        font-weight: 600;
      }
    `,
  ];
}
